import CustomHistory from "../../CustomHistory";
import {FrontendRoutes} from "../../constants";
import ProgrammeBGImage from "../../assets/img/background/programme-bg.jpeg";
import HomeBGImage from "../../assets/img/background/home-bg.png";
import NetworkBGImage from "../../assets/img/background/network-lg-bg.png";
import BallroomBGImage from "../../assets/img/background/ballroom-bg.png";
import PhotoBoothPageImage from "../../assets/img/background/photo-booth-bg.png";
import SocialWallBGImage from "../../assets/img/background/social-wall-bg.png";
import CountDownBGImage from "../../assets/img/background/countdown-bg.png";
import LogoutBGImage from "../../assets/img/logout-bg-img.png";
import firebase from "firebase";

export const getBgUrl = (el) => {
    if (!el)
        return '';
    let bg = "";
    if (el.currentStyle) { // IE
        bg = el.currentStyle.backgroundImage;
    } else if (document.defaultView && document.defaultView.getComputedStyle) { // Firefox
        bg = document.defaultView.getComputedStyle(el, "").backgroundImage;
    } else { // try and get inline style
        bg = el.style.backgroundImage;
    }
    return bg.replace(/url\(['"]?(.*?)['"]?\)/i, "$1");
}

const UserTableStructure = {
    "CustID": 5512,
    "FirstName": "Joel",
    "LastName": "Goh",
    "Email": "joelgoh@trinax.sg",
    "Company": "Trinax",
    "JobTitle": "",
    "Industry": 0,
    "IndustryOther": "",
    "Department": 0,
    "EventCountry": 0,
    "CountryOther": "",
    "CustType": 0
}

export function getBackground(url) {
    url = url || CustomHistory.location.pathname
    if (url.includes(FrontendRoutes.PROGRAMME))
        return ProgrammeBGImage;
    else if (url.includes(FrontendRoutes.HOME))
        return HomeBGImage;
    else if (url.includes(FrontendRoutes.CONVERSATION))
        return NetworkBGImage;
    else if (url.includes(FrontendRoutes.BALLROOM()))
        return BallroomBGImage;
    else if (url.includes(FrontendRoutes.PHOTO_BOOTH))
        return PhotoBoothPageImage;
    else if (url.includes(FrontendRoutes.SOCIAL_WALL))
        return SocialWallBGImage;
    else if (url.includes(FrontendRoutes.LOGOUT))
        return LogoutBGImage;
    else if (url.includes(FrontendRoutes.UNAUTHORIZED))
        return LogoutBGImage;
    else return CountDownBGImage
}

export const getCurrentUser = () => JSON.parse(localStorage.getItem('user'))

export function isPrivateRoute() {
    return [
        FrontendRoutes.SOCIAL_WALL,
        FrontendRoutes.PHOTO_BOOTH,
        FrontendRoutes.CONVERSATION,
        FrontendRoutes.BALLROOM(),
        FrontendRoutes.PROGRAMME,
        FrontendRoutes.HOME,
        FrontendRoutes.FEEDBACK
    ].includes(window.location.pathname)
}

String.prototype.takeRight = function (n) {
    return this.slice(-n)
}

export function encodeToFirebase(string) {
    return string.replace(/[\s.\/\$\[\]#%]/g, '')
}

export function updateOnlineStatus(user, time) {
    return firebase.database()
        .ref('/userping/' + encodeToFirebase(`${user.CustID}`))
        .set(time)
        .catch(err => console.log('error is here for ' + user.CustID, err))
}

export function updateHideStatus(user, value) {
    return firebase.database()
        .ref('/userHideStatus/' + user.CustID)
        .set(value)
        .catch(err => console.log('error is here for ' + user.CustID, err));
}

const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

export function getTimeOfMessage(messageTimestamp) {
    let d = new Date(parseInt(messageTimestamp));
    let hour = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
    let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
    return `${d.getDate()} ${monthNames[d.getMonth()]}, ${hour}:${min}`;
};